import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RetrieveAllTranslationsRequest } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'
import { RetrieveAllTranslationsResponse } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'

export const retrieveAllTranslations = (request: RetrieveAllTranslationsRequest, options?: CashRequestOptions) =>
  post<RetrieveAllTranslationsRequest, RetrieveAllTranslationsResponse>(
    '/2.0/cash/retrieve-all-translations',
    request,
    { ...options, rejectOnError: true }
  )
